import React, { Component } from 'react';

const defaultProps = {
    isMulti: false,
    value: undefined,
    inputValue: undefined,
    options: [],
};

const callProp = (obj, propName, ...args) => {
    if (typeof obj[propName] === 'function') {
        obj[propName].apply(null, args);
    }
};

const createOption = value => ({
    label: value,
    value: `new-option-${value}`,
    __isNew__: true,
});

const compareOption = (option, inputValue) => (
    !!inputValue && !!option && (
        (option.value || '').toString() === inputValue || (option.label || '').toString() === inputValue
    )
);

const hasOption = (options, inputValue) => (
    (options || []).some(option => compareOption(option, inputValue))
);

const handleKeyDown = (props, inputValue, value) => (event) => {
    callProp(props, 'onKeyDown', event);
    if (event.isDefaultPrevented()) {
        return;
    }

    if (['Enter', 'Tab'].includes(event.key)) {
        const { isMulti, options } = props;
        const formattedInputValue = inputValue && inputValue.trim();

        const isNew = !hasOption(options, formattedInputValue);
        const isSelected = hasOption(isMulti ? value : [value], formattedInputValue);
        const isEmpty = formattedInputValue === '';

        if (!isEmpty && isNew) {
            if (!isSelected) {
                const nextValue = isMulti
                    ? [...(value || []), createOption(formattedInputValue)]
                    : createOption(formattedInputValue);

                callProp(props, 'onChange', nextValue, { action: 'create-option' });
                callProp(props, 'onInputChange', '', { action: 'set-value' });
            }

            event.preventDefault();
        }
    }
};

export const withCreatableCreateOnEnterOrTab = (SelectComponent) => {
    class WithCreatableCreateOnEnterOrTab extends Component {
        focus() {
            return this.select.focus();
        }

        blur() {
            return this.select.blur();
        }

        render() {
            const {
                value,
                inputValue,
                ...props
            } = this.props;

            return (
                <SelectComponent
                    ref={(ref) => { this.select = ref; }}
                    formatCreateLabel={label => label}
                    getNewOptionData={createOption}
                    inputValue={inputValue}
                    value={value}
                    {...props}
                    onKeyDown={handleKeyDown(props, inputValue, value)}
                />
            );
        }
    }

    WithCreatableCreateOnEnterOrTab.defaultProps = defaultProps;

    return WithCreatableCreateOnEnterOrTab;
};
